<div class="welcome-container">
  @if(userName()) {
    <h1 class="h1 greeting">{{ 'menu.greeting' | translate: { userName: userName()} }}</h1>
  } @else {
    <h1 class="h1 greeting">{{ 'menu.greeting-empty' | translate }}</h1>
  }
</div>
